// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"AboutUs_pageWrapper__2yYTS","pageContainer":"AboutUs_pageContainer__1PHSy","pageSection":"AboutUs_pageSection__2kXR4"};